import Actions from '../../odata/actions';

const actions = new Actions('xeroPerson', 'xeroPersons');

export default actions;
